<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
  >
    <template v-slot:activator="{ on }">
      <a
        href="javascript:;"
        class="d-inline-block px-1"
        v-on="on"
      >{{ $t('TaskList.Detail') }}
      </a>
    </template>
    <v-card>
      <v-card-title>
        {{ $t('Outbox.FlowRecords') }}
      </v-card-title>
      <v-card-text>
        <table class="text--primary">
          <tr
            v-for="(status, index) in item.workflowStatusList"
            :key="status.workItemId"
          >
            <td class="font-weight-light pr-4">
              <template
                v-if="status.completedTime"
              >
                {{ momentWithHyphen(status.completedTime).format('YYYY-MM-DD HH:mm') }}
              </template>
              <template
                v-else
              >
                {{ momentWithHyphen(status.initiatedTime).format('YYYY-MM-DD HH:mm') }}
              </template>
            </td>
            <td>
              <template v-if="index===0">
                <span v-show="item.workflowStatusList[0].status === 'A'">{{ $t('TaskList.Waiting') }}</span> {{ $chPtObjData('chinStaffName', status) }} {{ $chPtObjData('chinWorkflowStatusDesc', status) }}
              </template>
              <template v-else>
                {{ $chPtObjData('chinStaffName', status) }}
              </template>
            </td>
          </tr>
        </table>
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="primary"
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  table td {
    padding-bottom: 4px;
  }
</style>

<script>

import { momentWithHyphen } from '@/utils/datetimeUtil'

export default {
  components: {
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      dialog: false
    }
  },
  methods: {
    momentWithHyphen: momentWithHyphen
  }
}
</script>
